import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import sImg1 from "../../images/story/image-left-1.jpg";
import sImg2 from "../../images/story/image-left-2.jpg";
import sImg3 from "../../images/story/image-left-3.jpg";

import srImg1 from "../../images/story/image-right-1.jpg";
import srImg2 from "../../images/story/image-right-2.jpg";
import srImg3 from "../../images/story/image-right-3.jpg";

gsap.registerPlugin(ScrollTrigger);

interface StorySectionProps {
  stClass?: string;
}

interface Story {
  sImg: string;
  srImg: string;
  title: string;
  description: string;
}

const Storys: Story[] = [
  {
    sImg: sImg1,
    srImg: srImg1,
    title: "La primera vez que nos vimos",
    description:
      "A esto le llamo destino, que a pesar de haber estado en la misma preparatoria, nunca nos habíamos cruzado hasta ese día. Fue el primer día de clases en la Universidad.",
  },
  {
    sImg: sImg2,
    srImg: srImg2,
    title: "Donde todo comenzó",
    description:
      "Cada uno tenía su historia y cada uno iba trabajando en su camino, ambos buscando sus metas. Y por azares del destino nos encontramos casi a punto de comenzar las clases en la escuela.",
  },
  {
    sImg: sImg3,
    srImg: srImg3,
    title: "Ella dijo que sí",
    description:
      "Hubo un día que sólo supimos que era el momento indicado, fuimos a un concierto de Bruno Mars, fue un día inolvidable porque disfrutamos mucho de la música y cuando ya el día casi terminaba hice la pregunta y ella dijo que sí.",
  },
];

const StorySection: React.FC<StorySectionProps> = ({ stClass }) => {
  const storySlideRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const slideContainer = storySlideRef.current;
    if (!slideContainer) return;

    ScrollTrigger.getAll()
      .filter(
        (trigger) =>
          trigger.trigger &&
          trigger.trigger instanceof HTMLElement &&
          trigger.trigger.classList.contains("story-slide")
      )
      .forEach((trigger) => trigger.kill());

    if (window.innerWidth <= 991) return;

    const sections = gsap.utils.toArray<HTMLElement>(
      ".story-item",
      slideContainer
    );
    if (!sections.length) return;

    const scrollTween = gsap.to(sections, {
      xPercent: -100 * (sections.length - 1),
      ease: "none",
      scrollTrigger: {
        trigger: slideContainer,
        pin: true,
        scrub: 0.2,
        snap: 1 / (sections.length - 1),
        end: () => "+=" + slideContainer.offsetWidth,
        onUpdate: (self) => {
          const progressBar = document.querySelector(".progress-bar");
          if (progressBar instanceof HTMLElement) {
            gsap.to(progressBar, { scaleX: self.progress, ease: "none" });
          }
        },
      },
    });

    return () => {
      scrollTween.scrollTrigger?.kill();
      ScrollTrigger.getAll()
        .filter(
          (trigger) =>
            trigger.trigger &&
            trigger.trigger instanceof HTMLElement &&
            trigger.trigger.classList.contains("story-slide")
        )
        .forEach((trigger) => trigger.kill());
    };
  }, []);

  return (
    <section className={`wpo-story-section ${stClass || ""}`}>
      <div className="container">
        <div className="story-wrap">
          <div className="story-slide" ref={storySlideRef}>
            {Storys.map((story, index) => (
              <div className="story-item" key={index}>
                <div className="item-wrap">
                  <div className="story-crad">
                    <div className="image-left">
                      <img src={story.sImg} alt={story.title} />
                    </div>
                    <div className="story-content">
                      <h2>{story.title}</h2>
                      <p>{story.description}</p>
                    </div>
                  </div>
                  <div className="image-right">
                    <img src={story.srImg} alt={story.title} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="progress-bar"></div>
    </section>
  );
};

export default StorySection;
